/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Plan_Edit_Move_ToInputs */

const en_us2_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move to ${i?.day}`)
};

const pt_br2_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover para ${i?.day}`)
};

const es_419_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover a ${i?.day}`)
};

const pt_pt2_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover para ${i?.day}`)
};

const fr_fr2_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Déplacer vers ${i?.day}`)
};

const de_de2_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nach ${i?.day} verschieben`)
};

const it_it2_plan_edit_move_to = /** @type {(inputs: Plan_Edit_Move_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sposta a ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Move to {day}" |
*
* @param {Plan_Edit_Move_ToInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_move_to = /** @type {((inputs: Plan_Edit_Move_ToInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Move_ToInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_move_to(inputs)
	if (locale === "es-419") return es_419_plan_edit_move_to(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_move_to(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_move_to(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_move_to(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_move_to(inputs)
	return en_us2_plan_edit_move_to(inputs)
});
export { plan_edit_move_to as "plan-edit.move_to" }